export default {
  effects: {
    captions: {
      blur: 'Suddig',
      crop: 'Beskära',
      enhance: 'Öka',
      flip: 'Flip',
      grayscale: 'Grayscale',
      invert: 'Invertera',
      mirror: 'Återspegla',
      rotate: 'Rotera',
      sharp: 'Skärpa',
    },
    apply: 'Använda',
  },
}

